import { render, staticRenderFns } from "./AutoMarketingForm.vue?vue&type=template&id=3b6d83a4&scoped=true&"
import script from "./AutoMarketingForm.vue?vue&type=script&lang=js&"
export * from "./AutoMarketingForm.vue?vue&type=script&lang=js&"
import style0 from "./AutoMarketingForm.vue?vue&type=style&index=0&id=3b6d83a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d83a4",
  null
  
)

export default component.exports